import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, Modal, PrimaryButton, setDateWithTimezone, toISOStringWithoutTimezone, toast } from '@systemeio/ui';
import { BlogPostId, BlogPostsInterface } from 'modules/blogs/types/blog-posts-interface';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useSchedulePostApi } from '../hooks/use-schedule-post-api';
export interface SchedulePostModalProps {
  opened: boolean;
  onClose: () => void;
  post: BlogPostsInterface;
  onSchedulePost: (postId: BlogPostId, data: BlogPostsInterface) => void;
}
export const SchedulePostModal = t0 => {
  const $ = _c(41);
  const {
    opened,
    onClose,
    post,
    onSchedulePost
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [dateTimePicker, setDateTimePicker] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const {
    schedulePost
  } = useSchedulePostApi();
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      onClose();
      setDateTimePicker(null);
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClosed = t1;
  let t2;
  let t3;
  if ($[2] !== dateTimePicker || $[3] !== opened || $[4] !== user) {
    t2 = () => {
      if (opened && !dateTimePicker && user) {
        const date = setDateWithTimezone(undefined, user.timezone);
        date.setHours(date.getHours() + 1);
        setDateTimePicker(toISOStringWithoutTimezone(date));
      }
    };
    t3 = [opened, dateTimePicker, user];
    $[2] = dateTimePicker;
    $[3] = opened;
    $[4] = user;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== dateTimePicker || $[8] !== onClosed || $[9] !== onSchedulePost || $[10] !== post || $[11] !== schedulePost || $[12] !== t) {
    t4 = async () => {
      setIsFetching(true);
      ;
      try {
        if (dateTimePicker) {
          const response = await schedulePost(post.id, {
            activatedAt: dateTimePicker
          });
          onSchedulePost(post.id, response);
        }
        onClosed();
        toast.success(t("dashboard.blog.posts.created"));
      } catch (t5) {
        const e = t5;
      }
      setIsFetching(false);
    };
    $[7] = dateTimePicker;
    $[8] = onClosed;
    $[9] = onSchedulePost;
    $[10] = post;
    $[11] = schedulePost;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleConfirm = t4;
  let t5;
  if ($[14] !== t) {
    t5 = t("dashboard.blog.posts.schedule_modal_title");
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = date_0 => {
      setDateTimePicker(date_0);
    };
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = user?.createdAt;
  const t8 = user?.timezone;
  const t9 = user?.dateFormat;
  const t10 = user?.timeFormat;
  let t11;
  if ($[17] !== dateTimePicker || $[18] !== intlLocale || $[19] !== t10 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t11 = <DateTimePicker key="date" value={dateTimePicker} onChange={t6} createdAt={t7} timezone={t8} userDateFormat={t9} userTimeFormat={t10} intlLocale={intlLocale} />;
    $[17] = dateTimePicker;
    $[18] = intlLocale;
    $[19] = t10;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = !dateTimePicker;
  let t13;
  if ($[24] !== handleConfirm) {
    t13 = e_0 => {
      e_0.preventDefault();
      handleConfirm();
    };
    $[24] = handleConfirm;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("dashboard.blog.posts.save_and_schedule");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isFetching || $[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
    t15 = <div className="flex justify-center"><PrimaryButton isFetching={isFetching} disabled={t12} width="large" onClick={t13} type="submit">{t14}</PrimaryButton></div>;
    $[28] = isFetching;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t11 || $[34] !== t15) {
    t16 = <form className="m-auto flex max-w-fit flex-col gap-6 lg:gap-10">{t11}{t15}</form>;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== onClosed || $[37] !== opened || $[38] !== t16 || $[39] !== t5) {
    t17 = <><Modal isCentered={true} opened={opened} onClose={onClosed} title={t5}>{t16}</Modal></>;
    $[36] = onClosed;
    $[37] = opened;
    $[38] = t16;
    $[39] = t5;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};